
// Deployment trigger: 2026-04-24
import { GameType, Campaign, Prize, Project, Question } from './types';

export const GAME_TEMPLATES = [
  { id: GameType.SPIN_WHEEL, name: 'Spin To Win', description: 'Classic engagement wheel with customizable segments.', icon: 'RotateCcw' },
  { id: GameType.SCRATCH_CARD, name: 'Scratch & Win', description: 'Interactive scratchable surface revealing prizes.', icon: 'Hand' },
  { id: GameType.RAFFLE, name: 'Grand Raffle', description: 'Delayed draw for high-value prizes. Builds massive leads.', icon: 'Ticket' },
  { id: GameType.MYSTERY_BOX, name: 'Mystery Box', description: 'Curiosity-driven game where users pick a chest.', icon: 'Package' },
  { id: GameType.SLOT_MACHINE, name: 'Lucky Slots', description: 'Vegas-style excitement for high conversion.', icon: 'Dices' },
  { id: GameType.GIFT_RAIN, name: 'Catch The Gifts', description: 'Falling items game that boosts interaction time.', icon: 'ArrowDownCircle' },
  { id: GameType.TRIVIA, name: 'Quick Quiz', description: 'Answer a question correctly to win a coupon.', icon: 'HelpCircle' },
];

// Games enabled by default for new setups (admins can change this in settings).
export const DEFAULT_ENABLED_GAMES: GameType[] = [
  GameType.SPIN_WHEEL,
  GameType.RAFFLE,
  GameType.TRIVIA,
];

export const INITIAL_PRIZES: Prize[] = [
  { id: '1', name: '20% OFF All Services', type: 'digital', value: 'SERVICE20', probability: 40, color: '#f87171', winnersCount: 1 },
  { id: '2', name: '20% OFF Gift Card', type: 'digital', value: 'GIFTCARD20', probability: 40, color: '#fb923c', winnersCount: 1 },
  { id: '3', name: 'Free Drink', type: 'physical', value: 'DRINKFREE', probability: 15, color: '#ffc107', winnersCount: 1 },
  { id: '4', name: 'Better luck next time!', type: 'empty', value: '', probability: 5, color: '#94a3b8', winnersCount: 1 },
];

export const INITIAL_RAFFLE_PRIZES: Prize[] = [
  { id: 'r1', name: 'LV Bag', type: 'physical', value: 'LVBAG', probability: 10, color: '#f87171', winnersCount: 1 },
  { id: 'r2', name: '100$ Gift Cards', type: 'digital', value: '100GC', probability: 20, color: '#fb923c', winnersCount: 1 },
  { id: 'r3', name: 'Tumblers', type: 'physical', value: 'TUMBLER', probability: 30, color: '#ffc107', winnersCount: 1 },
  { id: 'r4', name: 'Free Pedicure', type: 'digital', value: 'PEDICURE', probability: 40, color: '#94a3b8', winnersCount: 1 },
];

export const DEFAULT_QUESTIONS: Question[] = [
  {
    id: 'q1',
    text: 'What is our brand color?',
    options: ['Indigo', 'Red', 'Green', 'Yellow'],
    correctIndex: 0
  }
];

export const MOCK_PROJECTS: Project[] = [
  // Fixed missing properties for Project type
  { id: 'p1', name: 'E-commerce Store', domain: 'mystore.com', createdAt: '2023-01-01', emailQuota: 1000, smsQuota: 100, emailUsed: 120, smsUsed: 15, ownerId: 'mock-owner' },
  // Fixed missing properties for Project type
  { id: 'p2', name: 'SaaS Platform', domain: 'app.service.io', createdAt: '2023-05-10', emailQuota: 5000, smsQuota: 500, emailUsed: 450, smsUsed: 42, ownerId: 'mock-owner' }
];

export const MOCK_CAMPAIGNS: Campaign[] = [
  {
    id: 'c1',
    projectId: 'p1',
    name: 'Summer Sale Spin',
    type: GameType.SPIN_WHEEL,
    prizes: INITIAL_PRIZES,
    active: true,
    createdAt: '2023-10-01',
    leadsCount: 124,
    viewCount: 2500,
    conversionRate: 4.96
  },
  {
    id: 'c4',
    projectId: 'p1',
    name: 'iPhone 15 Giveaway',
    type: GameType.RAFFLE,
    prizes: [{ id: 'rp1', name: 'iPhone 15 Pro', type: 'physical', value: 'IPHONE_PICK', probability: 100, color: '#6366f1' }],
    active: true,
    createdAt: '2024-01-01',
    endDate: '2024-12-31',
    winnerCount: 1,
    leadsCount: 542,
    viewCount: 8900,
    conversionRate: 6.09
  }
];